import { Button, Typography } from "@suraasa/placebo-ui"
import { RefreshDouble } from "iconoir-react"
import React from "react"

const InaudibleAudioState = ({ onRetry }: { onRetry: () => void }) => {
  return (
    <div className="flex items-center justify-between gap-2 rounded-lg border border-critical bg-critical-50 px-3 py-2.5 text-critical-600">
      <div>
        <Typography className="mb-0.75" variant="title4">
          No audio detected
        </Typography>
        <Typography className="mb-0.75" variant="smallBody">
          The audio provided is inaudible. Kindly re-record with clearer sound
          and ensure you are speaking closer to the microphone.
        </Typography>
      </div>{" "}
      <Button
        rounded
        startAdornment={<RefreshDouble />}
        color="black"
        onClick={onRetry}
      >
        Retry
      </Button>
    </div>
  )
}

export default InaudibleAudioState
